import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-405d5d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approval-container" }
const _hoisted_2 = {
  key: 0,
  class: "approval-tips",
  style: {"color":"rgba(232, 126, 4, 1)"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 当前节点以下任意一人通过即可")
const _hoisted_4 = {
  key: 1,
  class: "approval-tips",
  style: {"color":"#ec1d1d"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 当前节点以下所有人需全部通过")
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "approval-title" }
const _hoisted_9 = { class: "approval-title-content" }
const _hoisted_10 = {
  key: 0,
  class: "relation"
}
const _hoisted_11 = { class: "approval-content-wrapper" }
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = { class: "approval-title" }
const _hoisted_14 = { class: "approval-title-content" }
const _hoisted_15 = {
  key: 0,
  class: "relation"
}
const _hoisted_16 = {
  key: 1,
  class: "ant-steps-item-description"
}
const _hoisted_17 = {
  key: 0,
  style: {"margin-left":"0px","margin-bottom":"54px","line-height":"22px"}
}
const _hoisted_18 = {
  class: "reject-text",
  style: {"margin-left":"0px"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "remark" }, "备注:", -1))
const _hoisted_21 = { style: {"color":"#333"} }
const _hoisted_22 = {
  key: 1,
  class: "approval-file-wrapper"
}
const _hoisted_23 = { style: {"display":"flex","word-break":"break-all"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "remark" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", null, "附件:")
  ])
], -1))
const _hoisted_25 = { style: {"flex-shrink":"0","align-self":"flex-start"} }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "reject-text"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 0,
  class: "remark"
}
const _hoisted_32 = {
  key: 1,
  class: "remark"
}
const _hoisted_33 = { style: {"color":"#333"} }
const _hoisted_34 = { style: {"display":"flex","word-break":"break-all"} }
const _hoisted_35 = { class: "remark" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件:", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { style: {"flex-shrink":"0","align-self":"flex-start"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_42 = {
  key: 1,
  class: "recall"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "remark" }, "撤回:", -1))
const _hoisted_44 = { style: {"color":"#333"} }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "remark",
  style: {"display":"inline","margin-right":"15px"}
}, "U8C帐号:", -1))
const _hoisted_47 = { style: {"color":"#333"} }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "remark" }, "备注:", -1))
const _hoisted_52 = { style: {"color":"#333"} }
const _hoisted_53 = { style: {"display":"flex","word-break":"break-all"} }
const _hoisted_54 = { class: "remark" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件:", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { style: {"flex-shrink":"0","align-self":"flex-start"} }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("下载")

import { ref, watch, withDefaults } from "vue";
import Description from "@/components/Description.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { Workflow } from "../types/procss";
import { GetWorkflowDetailList } from "../api/process";
import { message } from "ant-design-vue";
import { downloadByUrl } from "@/utils/download";
import { getFileType } from "@/utils/type";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: 0 },
    isLoadHistory: { default: 1 },
    refresh: { type: Boolean, default: false },
    BranchCompanyFlowId: { default: -1 },
    isOpenPage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { id: number, isLoadHistory: number, refresh: boolean, BranchCompanyFlowId: number, isOpenPage: boolean }

const Spinning = ref<boolean>(false);
const workflowDetails = ref<Workflow[]>([]);
const currentStep = ref<number>(0);



watch(
  () => props.refresh,
  (val, oldval) => {
    if (val != oldval) {
      getWorkDetail(props.id);
    }
  }
);
// 获取审批详情
const getWorkDetail = async (workflow_id: number) => {
  if (workflow_id == -1 || workflow_id == 0) return;
  Spinning.value = true;
  let param = {
    WorkFlowId: workflow_id,
    IsLoadHistory: props.isLoadHistory,
  };
  if (props.BranchCompanyFlowId > -1) {
    param.id = props.BranchCompanyFlowId;
  }
  const { Data, Success, Message } = await GetWorkflowDetailList(param);
  if (Success) {
    workflowDetails.value = Data;
    Spinning.value = false;
    currentStep.value = workflowDetails.value.findIndex(
      (item) => item.IsCurrent == 1
    );
    if (currentStep.value == -1) {
      currentStep.value = workflowDetails.value.length - 1;
    }
  } else {
    message.warning(Message);
    Spinning.value = false;
    //todo：无权限时怎么操作
  }
};

watch(
  () => props.id,
  (val: number) => {
    getWorkDetail(val);
  },
  {
    immediate: true,
  }
);

const handlePreview = (url: string) => {
  const type = getFileType(url);
  if (type == 3 || type == 6 || type == 7) {
    window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
  } else {
    window.open(url);
  }
};

const handleDownload = (filename: string, Id: string) => {
  downloadByUrl(filename, Id);
};
const clickPhotoUrl = (item: any) => {
  if (item.JumpUrl) {
    window.open(item.JumpUrl);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_steps, {
      class: "approval-step",
      "progress-dot": "",
      current: currentStep.value,
      direction: "vertical"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflowDetails.value, (info, index) => {
          return (_openBlock(), _createBlock(_component_a_step, {
            key: index,
            class: _normalizeClass({
          'sub-content': info.DetailList && info.DetailList.length > 1,
          'third-content':
            workflowDetails.value[index + 1] &&
            workflowDetails.value[index + 1].DetailList.length > 1,
        })
          }, {
            title: _withCtx(() => [
              (
              info.DetailList &&
              info.DetailList.length > 1 &&
              info.ApproveType == 1 //或签
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_unref(InfoCircleOutlined), {
                      style: {"margin":"0 5px 0 14px"},
                      class: _normalizeClass(__props.isOpenPage ? 'approvalMR34' : '')
                    }, null, 8, ["class"]),
                    _hoisted_3
                  ]))
                : (
              info.DetailList &&
              info.DetailList.length > 1 &&
              info.ApproveType == 2 //会签
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_unref(InfoCircleOutlined), {
                        style: {"margin":"0 5px 0 14px"},
                        class: _normalizeClass(__props.isOpenPage ? 'approvalMR34' : '')
                      }, null, 8, ["class"]),
                      _hoisted_5
                    ]))
                  : _createCommentVNode("", true),
              (info.DetailList && info.DetailList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (info.ApproveType == 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
                  info.DetailList.length == 1 ? '' : 'or-item',
                  __props.isOpenPage && info.DetailList.length !== 1
                    ? 'approvalMR24'
                    : '',
                ])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.DetailList, (_item, _index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: _index }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["approval-content-wrapper", _index < 3 ? 'nomargin' : ''])
                              }, [
                                _createElementVNode("img", {
                                  class: _normalizeClass(["approval-avator", _item.JumpUrl ? 'approval-avator-pointer' : '']),
                                  src: _item.PhotoUrl,
                                  onClick: ($event: any) => (clickPhotoUrl(_item))
                                }, null, 10, _hoisted_7),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("span", _hoisted_9, _toDisplayString(_item.PositionName), 1),
                                  _createVNode(Description, {
                                    "staff-type": info.StaffType || '',
                                    infoObj: _item
                                  }, null, 8, ["staff-type", "infoObj"])
                                ])
                              ], 2),
                              (_index != info.DetailList.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "或"))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(info.DetailList, (_item, _index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: _index }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                class: _normalizeClass(["approval-avator", _item.JumpUrl ? 'approval-avator-pointer' : '']),
                                src: _item.PhotoUrl,
                                onClick: ($event: any) => (clickPhotoUrl(_item))
                              }, null, 10, _hoisted_12),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_item.PositionName), 1),
                                _createVNode(Description, {
                                  "staff-type": info.StaffType || '',
                                  infoObj: _item
                                }, null, 8, ["staff-type", "infoObj"])
                              ])
                            ]),
                            (
                    _index != info.DetailList.length - 1 &&
                    info.ApproveType == 2
                  )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "且"))
                              : _createCommentVNode("", true),
                            (
                    _index != info.DetailList.length - 1 &&
                    info.ApproveType == 2
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (_item?.Description || _item?.Remark.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          (_item.Description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _hoisted_20,
                                                _createElementVNode("span", _hoisted_21, _toDisplayString(_item.Description), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_item.Remark.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                  _hoisted_24,
                                                  _createElementVNode("div", null, _toDisplayString(_item.Remark[0]?.FileName), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                  _createVNode(_component_a_button, {
                                                    type: "link",
                                                    style: {"padding-right":"0","padding-top":"0","line-height":"22px"},
                                                    onClick: ($event: any) => (handlePreview(_item.Remark[0].FileUrl))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_26
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_a_button, {
                                                    type: "link",
                                                    onClick: ($event: any) => (
                              handleDownload(
                                _item.Remark[0].FileName,
                                _item.Remark[0].FileId
                              )
                            ),
                                                    style: {"padding-right":"0","padding-top":"0","line-height":"22px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_27
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            description: _withCtx(() => [
              (info.DetailList.length == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (
                info.DetailList[0]?.Description ||
                info.DetailList[0]?.Remark.length > 0
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (info.DetailList[0]?.Description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (info.StaffType == 3 || info.StaffType == 6)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "撤回:"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_32, "备注:")),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(info.DetailList[0]?.Description), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.DetailList[0].Remark, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "approval-file-wrapper"
                            }, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  (index == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _hoisted_38))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, _toDisplayString(item.FileName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  style: {"padding-right":"0","padding-top":"0","line-height":"22px"},
                                  onClick: ($event: any) => (handlePreview(item.FileUrl))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_40
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  onClick: ($event: any) => (handleDownload(item.FileName, item.FileId)),
                                  style: {"padding-right":"0","padding-top":"0","line-height":"22px"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_41
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          }), 128)),
                          (info.Status == 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("span", _hoisted_44, _toDisplayString(info.DetailList[0]?.Description), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.DetailList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(item.CustomerFields && item.CustomerFields.U8CAccount ? 'reject-text' : ''),
                  key: index
                }, [
                  (item.CustomerFields && item.CustomerFields.U8CAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("span", _hoisted_47, _toDisplayString(item.CustomerFields.U8CAccount), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              (
              info.DetailList.length > 1 &&
              index != info.DetailList.length - 1 &&
              info.ApproveType !== 2
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    (info.DetailList[0]?.Description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.DetailList, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "reject-text",
                              key: index
                            }, [
                              (item.Description || item.Remark.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createElementVNode("span", _hoisted_52, _toDisplayString(item.Description), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Remark, (item1, index1) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index1,
                                  class: "approval-file-wrapper"
                                }, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                      (item1.FileUrl)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _hoisted_57))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", null, _toDisplayString(item1.FileName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      style: {"padding-right":"0","padding-top":"0","line-height":"22px"},
                                      onClick: ($event: any) => (handlePreview(item1.FileUrl))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_59
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      onClick: ($event: any) => (handleDownload(item1.FileName, item1.FileId)),
                                      style: {"padding-right":"0","padding-top":"0","line-height":"22px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_60
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["current"])
  ]))
}
}

})